import { render, staticRenderFns } from "./FinancesIncomeWarehouseFormPercents.vue?vue&type=template&id=035a1bc0&scoped=true"
import script from "./FinancesIncomeWarehouseFormPercents.vue?vue&type=script&lang=js"
export * from "./FinancesIncomeWarehouseFormPercents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035a1bc0",
  null
  
)

export default component.exports